"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.FieldEditor = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var react_datepicker_1 = __importDefault(require("react-datepicker"));
var menu_button_1 = require("../menu-button/menu-button");
var menu_item_1 = require("../menu-button/menu-item");
var ui_common_1 = require("@codametrix/ui-common");
var isEmpty = ui_common_1.objectUtils.isEmpty;
/**
 * Fetches the initial label for a field based on the cell key, case edits, and value.
 * For billing_location fields, it attempts to find a mapped label from the case edits.
 *
 * @param cellKey - The key identifier for the cell
 * @param caseEdits - The current state of case edits
 * @param value - The current value of the field
 * @returns The label to display, or the original value if no mapping is found
 */
var fetchInitialLabel = function (cellKey, caseEdits, value) {
    var _a;
    if (cellKey === 'billing_location' &&
        !isEmpty(caseEdits) &&
        Object.keys(caseEdits).includes(cellKey)) {
        var mappedValues = (caseEdits === null || caseEdits === void 0 ? void 0 : caseEdits[cellKey]).mappedValues;
        var label = (_a = mappedValues === null || mappedValues === void 0 ? void 0 : mappedValues.find(function (map) {
            return (map === null || map === void 0 ? void 0 : map.value) === value;
        })) === null || _a === void 0 ? void 0 : _a.label;
        return label || value;
    }
    return value;
};
var FieldEditor = function (props) {
    var defaultClassname = 'col-4 col-md-12';
    var cellKey = props.cellKey, label = props.label, value = props.value, fieldType = props.fieldType, onChange = props.onChange, onSubmit = props.onSubmit, fieldEditorInfo = props.fieldEditorInfo, _a = props.className, className = _a === void 0 ? defaultClassname : _a, spreadable = __rest(props, ["cellKey", "label", "value", "fieldType", "onChange", "onSubmit", "fieldEditorInfo", "className"]);
    var classes = (0, classnames_1["default"])("".concat(cellKey, "-editor"), 'field-editor', 'encounter-info', className);
    var caseEdits = fieldEditorInfo.caseEdits;
    var updatedValue = value;
    var menuSelect;
    if (caseEdits && Object.keys(caseEdits).includes(cellKey)) {
        var _b = caseEdits[cellKey], newValue = _b.newValue, initialValue = _b.initialValue;
        updatedValue = (newValue === null || newValue === void 0 ? void 0 : newValue.length) > 0 ? newValue : initialValue !== null && initialValue !== void 0 ? initialValue : 'N/A';
        // setSelected(updatedValue.toString());
        if (fieldType === 'dictionary') {
            var options = caseEdits[cellKey].options;
            menuSelect = options.map(function (option, index) {
                return ((0, jsx_runtime_1.jsx)(menu_item_1.MenuItem, __assign({ onSelect: function (e) {
                        setSelected(e.currentTarget.innerText);
                        onChange(e.currentTarget.innerText);
                    } }, { children: (0, jsx_runtime_1.jsx)("div", { children: option }) }), "".concat(cellKey, "-").concat(option, "-").concat(index)));
            });
        }
    }
    if (fieldType === 'date' && updatedValue !== 'N/A') {
        updatedValue = ui_common_1.cmxDateTime.format(updatedValue.toString(), ui_common_1.cmxDateTime.FORMATS.DATE);
    }
    var _c = __read((0, react_1.useState)(fetchInitialLabel(cellKey, caseEdits, value.toString())), 2), selected = _c[0], setSelected = _c[1];
    react_1["default"].useEffect(function () {
        setSelected(fetchInitialLabel(cellKey, caseEdits, value.toString()));
    }, [value]);
    return (
    //@ts-ignore
    (0, jsx_runtime_1.jsxs)("div", __assign({}, spreadable, { className: classes }, { children: [fieldType === 'date' && ((0, jsx_runtime_1.jsx)("div", __assign({ className: "datepicker-qa date-field-editor" }, { children: (0, jsx_runtime_1.jsx)(react_datepicker_1["default"], { selected: selected !== 'N/A' || null || undefined
                        ? new Date("".concat(selected, " 00:00"))
                        : null, placeholderText: 'No Date Selected', onChange: function (e) {
                        var newTime = e.toISOString().split('T')[0];
                        setSelected(newTime);
                        onChange(newTime);
                    } }, updatedValue.toString()) }))), fieldType === 'dictionary' && ((0, jsx_runtime_1.jsx)("div", __assign({ className: "dictionary-menu-button tooltip", "data-tooltip": selected }, { children: (0, jsx_runtime_1.jsx)(menu_button_1.MenuButton, __assign({ label: selected !== 'N/A' ? "".concat(selected) : 'No Selection' }, { children: menuSelect }), updatedValue.toString()) })))] })));
};
exports.FieldEditor = FieldEditor;
FieldEditor.displayName = 'FieldEditor';
//# sourceMappingURL=field-editor.js.map